import dataBloedNietErnstigLMWH from "../../../../src/data/niet-ernstige-bloedingen-onder-lmwh-ongefractioneerde-heparine.json";
import BasicCollapse from "../../../../src/components/chart/interaction/basic-collapse/Chart.js";
import * as React from 'react';
export default {
  dataBloedNietErnstigLMWH,
  BasicCollapse,
  React
};